export const discountTypes = ["amount", "percentage"];
